import { render, staticRenderFns } from "./ProductSectionDialog.vue?vue&type=template&id=6cc9fb9d&"
import script from "./ProductSectionDialog.vue?vue&type=script&lang=js&"
export * from "./ProductSectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports